import Vue from 'vue'
import Vuex from 'vuex'
import jwtdecode from 'jwt-decode'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const defaultState = {
  apiEndpoint: process.env.BASE_API_ENDPOINT,
  storageEndpoint: process.env.BASE_STORAGE_ENDPOINT,
  notAuthUrls: [
    'auth/login', 'weather/regions', 'refresh'
  ],
  jwt: localStorage.getItem('t'),
  user: null,
  weatherRegions: [],
  weather: [],
  cameras: [],
  cards: [],
  interests: [],
  filter: 'all',
  alert: null,
  showModal: false
}

const actions = {
  RegisterByEmail: async ({ commit, state }, payload) => {
    await new Promise((resolve, reject) => {
      return Vue.prototype.$axios.post('auth/signup', payload)
        .then((response) => {
          commit('updateJWT', 'Bearer ' + response.data.token)
          resolve(response)
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.error(error)
          reject(error)
        })
    })
  },
  loginByEmail: async ({commit, state}, payload) => {
    await new Promise((resolve, reject) => {
      return Vue.prototype.$axios.post('auth/login', payload)
        .then((response) => {
          commit('updateJWT', 'Bearer ' + response.data.token)
          resolve(response)
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.error(error)
          reject(error)
        })
    })
  },
  refreshToken: async ({commit, state}) => {
    return new Promise((resolve, reject) => {
      return Vue.prototype.$axios.get('refresh')
        .then((response) => {
          commit('updateJWT', response.headers.authorization)
          resolve(response)
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.error(error)
          reject(error)
        })
    })
  },
  getUserInfo: async ({commit, state}) => {
    await new Promise((resolve, reject) => {
      Vue.prototype.$axios.get('auth/user')
        .then((response) => {
          commit('USER_UPDATED', response.data)
          resolve(response)
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.error(error)
          reject(error)
        })
    })
  },
  updateUserInfo: async ({ commit, state }, payload) => {
    await new Promise((resolve, reject) => {
      return Vue.prototype.$axios.put('auth/user', payload)
        .then((response) => {
          commit('USER_UPDATED', response.data)
          resolve(response)
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.error(error)
          reject(error)
        })
    })
  },
  updateUserInterests: async ({ commit, state }, payload) => {
    await new Promise((resolve, reject) => {
      return Vue.prototype.$axios.put('auth/user-interest', payload)
        .then((response) => {
          commit('USER_UPDATED', response.data)
          resolve(response)
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.error(error)
          reject(error)
        })
    })
  },
  getWeatherRegions: async ({commit, state}) => {
    await new Promise((resolve, reject) => {
      return Vue.prototype.$axios.get('weather/regions')
        .then((response) => {
          commit('WEATHER_REGIONS_UPDATED', response.data)
          resolve(response)
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.error(error)
          reject(error)
        })
    })
  },
  getWeatherData: async ({ commit, state }, id) => {
    await new Promise((resolve, reject) => {
      return Vue.prototype.$axios.get('weather/regions/' + id)
        .then((response) => {
          commit('WEATHER_UPDATED', response.data)
          resolve(response)
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.error(error)
          reject(error)
        })
    })
  },
  getCards: async ({commit, state}, page) => {
    return new Promise((resolve, reject) => {
      let url = (page === 1 || page === undefined) ? 'cards' : 'cards?page=' + page
      return Vue.prototype.$axios.get(url)
        .then((response) => {
          commit('CARDS_UPDATED', response.data)
          resolve(response)
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.error(error)
          reject(error)
        })
    })
  },
  getInterests: async ({commit, state}) => {
    await new Promise((resolve, reject) => {
      return Vue.prototype.$axios.get('interests')
        .then((response) => {
          commit('INTERESTS_UPDATED', response.data)
          resolve(response)
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.error(error)
          reject(error)
        })
    })
  },
  getCameras: async ({
    commit,
    state
  }) => {
    await new Promise((resolve, reject) => {
      return Vue.prototype.$axios.get('cameras')
        .then((response) => {
          commit('CAMERAS_UPDATED', response.data)
          resolve(response)
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.error(error)
          reject(error)
        })
    })
  },
  getFacebookLoginUrl: async ({commit, state}) => {
    return new Promise((resolve, reject) => {
      return Vue.prototype.$axios.get('auth/login/facebook')
        .then((response) => {
          console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  resetByEmail: async ({commit, state}, email) => {
    return new Promise((resolve, reject) => {
      return Vue.prototype.$axios.post('auth/recovery', {
        email: email
      })
        .then((response) => {
          console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  resetByToken: async ({commit, state}, resetinfo) => {
    return new Promise((resolve, reject) => {
      return Vue.prototype.$axios.post('auth/reset', {
        email: resetinfo.email,
        token: resetinfo.token,
        password: resetinfo.password
      })
        .then((response) => {
          console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getFacebookLoginUser: async ({commit, state}, code) => {
    return new Promise((resolve, reject) => {
      return Vue.prototype.$axios.get('auth/login/facebookUser?code=' + code)
        .then((response) => {
          console.log(response)
          commit('updateJWT', 'Bearer ' + response.data.token)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getGoogleLoginUrl: async ({commit, state}) => {
    return new Promise((resolve, reject) => {
      return Vue.prototype.$axios.get('auth/login/google')
        .then((response) => {
          console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getGoogleLoginUser: async ({commit, state}, code) => {
    return new Promise((resolve, reject) => {
      return Vue.prototype.$axios.get('auth/login/googleUser?code=' + code)
        .then((response) => {
          console.log(response)
          commit('updateJWT', 'Bearer ' + response.data.token)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getAlert: async ({commit, state}) => {
    await new Promise((resolve, reject) => {
      return Vue.prototype.$axios.get('alert')
        .then((response) => {
          if (response.status === 200) {
            commit('ALERT_UPDATED', response.data)
            console.log(response.data)
          } else {
            commit('ALERT_UPDATED', null)
          }
          resolve(response)
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.error(error)
          reject(error)
        })
    })
  }
}

const mutations = {
  USER_UPDATED: (state, user) => {
    state.user = user
  },
  WEATHER_REGIONS_UPDATED: (state, weatherRegions) => {
    state.weatherRegions = weatherRegions
  },
  WEATHER_UPDATED: (state, weather) => {
    state.weather = weather
  },
  CARDS_UPDATED: (state, cards) => {
    state.cards = cards
  },
  INTERESTS_UPDATED: (state, interests) => {
    state.interests = interests
  },
  CAMERAS_UPDATED: (state, cameras) => {
    state.cameras = cameras
  },
  FILTER_UPDATED: (state, filter) => {
    state.filter = filter
  },
  ALERT_UPDATED: (state, alert) => {
    state.alert = alert
  },
  updateJWT: (state, newToken) => {
    console.log('Update JWT')
    console.log(newToken)
    localStorage.setItem('t', newToken)
    Vue.prototype.$axios.defaults.headers.common['Authorization'] = newToken
    state.jwt = newToken
  },
  removeJWT: (state) => {
    localStorage.removeItem('t')
    Vue.prototype.$axios.defaults.headers.common['Authorization'] = null
    state.jwt = null
    state.user = null
    state.cards = []
    state.interests = []
  },
  updateUserData: (state) => {
    actions.getUserInfo()
  }
}

const getters = {
  weather: state => state.weather,
  weatherRegions: state => state.weatherRegions,
  user: state => state.user,
  cards: state => state.cards,
  cameras: state => state.cameras,
  interests: state => state.interests,
  alert: state => state.alert,
  filter: state => state.filter,
  storageEndpoint: state => state.storageEndpoint,
  isTokenExpired: (state, getters) => {
    const token = state.jwt
    if (token) {
      const decoded = jwtdecode(token)
      const now = Date.now()
      if ((now / 1000) > (decoded.iat + 628200)) {
        // Todo: Redirect to login
        let response = {
          status: false,
          action: 'login'
        }
        return response
      } else if ((now / 1000) > decoded.exp) {
        return true
      } else {
        return false
      }
    }
  },
  isUserLoggedOut: (state, getters) => {
    return !state.jwt
  }
}

export default new Vuex.Store({
  state: defaultState,
  getters,
  actions,
  mutations,
  plugins: [createPersistedState()]
})



// WEBPACK FOOTER //
// ./src/store/index.js